import { useOnMount } from "@hooks/index";
import React from "react";
import ReactModal from "react-modal";
import Wrapper from "./modal.styles";


export const ModalParent = () => {
  useOnMount(() => {
    ReactModal.setAppElement("#root");
  });
  return (
    <Wrapper id="modal-parent"/>
  );
};